<app-stepper-form
  header="Bulk Change of Address"
  formIcon="ic-change-address-20"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [form]="stepperForm"
  [isLoading]="isLoading()"
  [isInvalid]="areAllRowsHaveErrors"
  [showSteps]="false"
  (stepIndexChange)="onStepChange($event)"
>
  <div
    class="step-content"
    [class]="{'step-content-error': currentStep === StepsEnum.Summary && isGridIncludesError }"
  >
    <app-stepper-form-description
      formKey="484 A1"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    @if (currentStep === StepsEnum.FormDescription && isIndividual && bulkMatchesSelected.length > 1 && formModel.address.normalizedFullAddress) {
      <app-disclaimer
        color="light-gray"
        icon="ic-info-circle-20"
      >
        <div><i class="icon ic-info-circle-16"></i></div>
        <div class="text">
          We found that the current address is being used by {{ bulkMatchesSelected.length }} other
          entities.
          Do you need to update their addresses to the new one? Click
          <a
            [routerLink]="'/bulk-changes'"
            [queryParams]="{ address: formModel.address.normalizedFullAddress }"
          >here</a>
          to view the list and begin the process.
        </div>
      </app-disclaimer>
    }

    <section
      class="step-section"
      [formGroup]="form"
      [hidden]="currentStep !== StepsEnum.NewAddress"
    >
      <h1 class="h1-heading">New Address</h1>

      <div class="mb-3">
        <app-address-and-occupier-form-group
          [formGroup]="form"
          [minDateOfAddressChange]="minDate"
          [maxDateOfAddressChange]="maxDate"
          [useInternationalAddresses]="true"
          [occupierPartHidden]="trustOnly || isIndividual"
          [lateFeeMessage]="lateFeeMessage"
        />
      </div>

      @if (!trustOnly) {
        <div class="document-type mb-3">
          <app-radio
            label="Choose the type of document to generate"
            formControlName="documentationType"
            [options]="documentTypeOptions"
          />
        </div>
      }
    </section>

    <section
      class="step-section gap-32"
      [formGroup]="form"
      [hidden]="currentStep !== StepsEnum.Summary"
    >
      <div class="change">
        <h1 class="h1-heading">Change of Address</h1>

        @if (colDefs.length) {
          <app-list-grid-client-side
            class="bulk-change-grid"
            [rowData]="rows"
            [colDefs]="colDefs"
            [rowSelection]="rowSelection"
            [rowClassRules]="rowClassRules"
            [suppressRowClickSelection]="true"
            [paginationPageSizeSelector]="false"
            [suppressCellFocus]="true"
          />
        }
      </div>
    </section>
  </div>
</app-stepper-form>
